module.exports = __webpack_public_path__ + "static/img/akkuschrauber.9cdc31b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/akkuschrauber.png
// module id = 287
// module chunks = 0